// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  systemUrl: '/core/',
  //systemUrl: 'https://localhost:5001/',
  get apiUrl(): string {
    return this.systemUrl + 'api'
  },
  get signalRUrl(): string {
    return this.systemUrl + 'signalr'
  },
  get importSignalRUrl(): string {
    return this.systemUrl + 'importSignalR'
  },
  get propagateSignalRUrl(): string {
    return this.systemUrl + 'propagateSignalR'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
